/* eslint-disable no-prototype-builtins */
export function createObjectWithSelectedKeys<T extends Record<string, any>, K extends keyof T>(
  sourceObject: T,
  keysArray: K[]
): Pick<T, K> {
  const resultObject: Partial<T> = {};

  keysArray.forEach(key => {
    if (sourceObject.hasOwnProperty(key)) {
      resultObject[key] = sourceObject[key];
    }
  });

  return resultObject as Pick<T, K>;
}
